import React from 'react'
import { Container } from './Styled'

export const Index = ({ children }) => {
  return <Container>{children}</Container>
}

export default Index
